import "@/App.css";
import DemoApp from "@/demo/DemoApp";
import { previewMode } from "@/lib/previewConfig";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Deadlines from "@/pages/Deadlines";
import Reports from "@/pages/Reports";
import ReportDetail from "@/pages/ReportDetail";
import Tasks from "@/pages/Tasks";
import Users from "@/pages/Users";
import History from "@/pages/History";
import Organizations from "@/pages/Organizations";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/" replace />;
}

function SuperAdminRoute({ children }) {
  const { isSuperAdmin } = useAuth();
  return isSuperAdmin ? children : <Navigate to="/" replace />;
}

function TenantRoute({ children }) {
  const { isSuperAdmin } = useAuth();
  return isSuperAdmin ? <Navigate to="/escritorios" replace /> : children;
}

function ProtectedRoutes() {
  const { isAuthenticated, hydrated } = useAuth();
  if (!hydrated) return null;
  if (!isAuthenticated) return <Login />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/escritorios" element={<SuperAdminRoute><Organizations /></SuperAdminRoute>} />
        <Route path="/clientes" element={<TenantRoute><Clients /></TenantRoute>} />
        <Route path="/clientes/:clientId" element={<TenantRoute><ClientDetail /></TenantRoute>} />
        <Route path="/prazos" element={<TenantRoute><Deadlines /></TenantRoute>} />
        <Route path="/tarefas" element={<TenantRoute><Tasks /></TenantRoute>} />
        <Route path="/usuarios" element={<AdminRoute><Users /></AdminRoute>} />
        <Route path="/historico" element={<AdminRoute><History /></AdminRoute>} />
        <Route path="/fichas" element={<TenantRoute><Reports /></TenantRoute>} />
        <Route path="/fichas/:clientId" element={<TenantRoute><ReportDetail /></TenantRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  // The public preview remains synthetic by default. Staging must be explicitly
  // enabled at build time and connected only to a separately deployed test backend.
  if (previewMode === "demo") {
    return <DemoApp />;
  }
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <ProtectedRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
